import { SpacingFactorType } from './types';
import { getSpacingValueFromNumber } from './getSpacingValueFromNumber';

export const getSpacingValue = (factor: SpacingFactorType, addPx = false) =>
  typeof factor === 'string'
    ? factor
    : getSpacingValueFromNumber(factor, addPx);
